import React from "react";
import { useIsFetching, useIsMutating } from "react-query";
import Loader from "components/Loader";
import styles from "./LoadingIndicator.module.css";

// Queries/mutations opt out of the full-screen loader with meta: { blocking: false }
// when they run invisibly in the background (e.g. behind a modal that isn't open yet,
// or an optimistic action that already has its own inline feedback).
const isBlocking = (queryOrMutation) => queryOrMutation.meta?.blocking !== false;

const LoadingIndicator = () => {
  const isFetching = useIsFetching({ predicate: isBlocking });
  const isMutating = useIsMutating({ predicate: isBlocking });
  const isLoading = isFetching > 0 || isMutating > 0;

  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <Loader color="#243746" size={64} />
      <span className={styles.visuallyHidden}>Loading</span>
    </div>
  );
};

export default LoadingIndicator;
